// extracted by mini-css-extract-plugin
export var bodyRow = "_ge-d";
export var cardColumns = "_ge-e";
export var ellipsesOverflow = "_ge-2";
export var flatBottomCorners = "_ge-3";
export var flatTopCorners = "_ge-4";
export var headerActionsDropdown = "_ge-f";
export var headerBottomRow = "_ge-c";
export var headerTopRow = "_ge-b";
export var orderDetailsWrapper = "_ge-0";
export var orderInfoContainer = "_ge-1";
export var productDetails = "_ge-9";
export var productImage = "_ge-5";
export var responsiveTable = "_ge-8";
export var shipmentContainer = "_ge-a";
export var tableBottomLeft = "_ge-6";
export var tableBottomRight = "_ge-7";